import { Box, Container, Typography, Paper, Avatar, Grid, Divider, Card, CardContent, IconButton, Stack, Button } from '@mui/material';
import { GitHub, Instagram, Email, Language, Description } from '@mui/icons-material';
import { Link } from 'react-router-dom';

function Founder() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 6 }}>
          <Typography variant="h2" gutterBottom sx={{ fontWeight: 'bold' }}>
            Meet the Founder
          </Typography>
          <Button
            component={Link}
            to="/resume"
            variant="contained"
            startIcon={<Description />}
            color="primary"
          >
            View Resume
          </Button>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 6 }}>
          <Avatar
            alt="Nikhilesh Rao(NR7)"
            src="/PFP.jpg"
            sx={{
              width: 200,
              height: 200,
              mb: 3,
              boxShadow: 3,
              border: '4px solid',
              borderColor: 'primary.main'
            }}
          />
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
            Nikhilesh Rao(NR7)
          </Typography>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Founder & CEO, TIXO - The IX Organisation
          </Typography>
          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <IconButton
              color="primary"
              aria-label="GitHub"
              component="a"
              href="https://github.com/officialTIXO"
              target="_blank"
            >
              <GitHub />
            </IconButton>
            <IconButton
              color="primary"
              aria-label="Instagram"
              component="a"
              href="https://instagram.com/thisisnr7"
              target="_blank"
            >
              <Instagram />
            </IconButton>
            <IconButton
              color="primary"
              aria-label="Email"
              component="a"
              href="mailto:nr7isgoat@proton.me"
            >
              <Email />
            </IconButton>
            <IconButton
              color="primary"
              aria-label="Website"
              component="a"
              href="https://ix-study.netlify.app"
              target="_blank"
            >
              <Language />
            </IconButton>
          </Stack>
        </Box>

        <Divider sx={{ mb: 6 }} />

        <Typography variant="h4" gutterBottom color="primary" sx={{ fontWeight: 'bold' }}>
          About the Founder
        </Typography>
        <Typography paragraph sx={{ mb: 4, fontSize: '1.1rem' }}>
          Nikhilesh Rao(NR7) is a motivated and entrepreneurial 9th grade student with a strong passion for technology, product building, and football. As the founder of The IX Organization (TIXO), he has led the early-stage development of IX-Study-an AI-powered study platform now known as IX-Study.
        </Typography>

        <Typography paragraph sx={{ mb: 4, fontSize: '1.1rem' }}>
          With experience in frontend and backend development using JavaScript, Node.js, and React, Nikhilesh Rao(NR7) has built IX-Study from the ground up. His technical skills are complemented by a competitive sports mindset, as he plays as a striker/left winger in footballL. This combination of technical knowledge and athletic discipline has shaped his approach to building educational technology.
        </Typography>

        <Typography paragraph sx={{ mb: 4, fontSize: '1.1rem' }}>
          Nikhilesh Rao(NR7) is skilled at taking initiative, building from scratch, and collaborating on vision-driven projects. His journey as a young founder demonstrates that age is not a barrier to creating meaningful technology solutions.
        </Typography>

        <Divider sx={{ mb: 6 }} />

        <Typography variant="h4" gutterBottom color="primary" sx={{ fontWeight: 'bold' }}>
          Vision for IX-Study
        </Typography>
        <Typography paragraph sx={{ mb: 4, fontSize: '1.1rem' }}>
          Nikhilesh Rao(NR7)'s vision for IX-Study is to create an AI-powered study platform that helps students learn more efficiently and effectively. The platform addresses common challenges students face, such as organizing study materials, creating effective flashcards, and preparing for exams.
        </Typography>

        <Typography paragraph sx={{ mb: 4, fontSize: '1.1rem' }}>
          IX-Study aims to transform education by leveraging AI technology to personalize the learning experience. By using advanced models like Meta's LLaMA 3 (70B) instruction-tuned model, the platform adapts to each student's unique learning style, helping them achieve their full potential more efficiently than ever before.
        </Typography>

        <Typography paragraph sx={{ mb: 4, fontSize: '1.1rem' }}>
          As an 9th grade student himself, Nikhilesh Rao(NR7) understands the challenges students face and is building solutions he wishes he had. His philosophy centers on making education more accessible, engaging, and effective through thoughtful application of technology.
        </Typography>

        <Divider sx={{ mb: 6 }} />

        <Grid container spacing={4} sx={{ mb: 4 }}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h5" gutterBottom color="primary" sx={{ fontWeight: 'bold' }}>
                  Education
                </Typography>
                <Typography paragraph>
                  • 9th Grade Student
                </Typography>
                <Typography paragraph>
                  • Self-taught programmer
                </Typography>
                <Typography paragraph>
                  • Continuous learner through online resources
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h5" gutterBottom color="primary" sx={{ fontWeight: 'bold' }}>
                  Experience
                </Typography>
                <Typography paragraph>
                  • Founder & Developer, IX-Study, 2025-Present
                </Typography>
                <Typography paragraph>
                  • Founder, The IX Organization (TIXO), 2025-Present
                </Typography>
                <Typography paragraph>
                  • Striker/Left Winger, Football
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Typography variant="h4" gutterBottom color="primary" sx={{ fontWeight: 'bold', mt: 4 }}>
          Message from the Founder
        </Typography>
        <Typography paragraph sx={{ mb: 4, fontSize: '1.1rem', fontStyle: 'italic' }}>
          "I created IX-Study with a vision to make education more accessible, personalized, and effective. Our AI-powered tools are designed to help students learn more efficiently and retain information longer. I believe that technology should enhance human potential, not replace it. As a student myself, I'm building the tools I wish I had. IX-Study is my contribution to the future of education."
        </Typography>
        <Typography paragraph sx={{ textAlign: 'right', fontWeight: 'bold' }}>
          - Nikhilesh Rao(NR7)
        </Typography>
      </Paper>
    </Container>
  );
}

export default Founder;
